import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { singleBreakpoints } from '../../constants/single-carousel-breakpoints';
import { NewsItem } from '../../interfaces/news-item';
import { environment } from 'src/environments/environment';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-widget-news-carousel',
  templateUrl: './widget-news-carousel.component.html',
  styleUrls: ['./widget-news-carousel.component.scss'],
})
export class WidgetNewsCarouselComponent implements OnInit {
  @Input({ required: true }) widgetData!: any;
  mockNew: NewsItem = {
    author: "",
    date: "",
    description: "",
    link: "",
    title: "",
    unitName: ""
  }
  news: NewsItem[] = [];
  @Output() widgetLoaded: EventEmitter<void> = new EventEmitter<void>();
  isLoading: boolean = false;
  isServerError: boolean = false;

  breakpoints = singleBreakpoints;

  @ViewChild('carousel') carousel: any;
  lockNext: boolean = false;
  lockPrev: boolean = true;

  constructor(private dataService: DataService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.isLoading = true;
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetArticlesAndNewsForWidget';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      maxDisplayItems: this.widgetData.maxDisplayItems,
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.news = responseData;
        this.isLoading = false;
        this.widgetLoaded.emit();

        setTimeout(() => {
          this.carousel?.nativeElement.swiper.on('slideChange', () => {
            setTimeout(() => {
              this.checkLockNavigation();
            }, 50);
          });
        }, 200);

      },
      error: (e: any) => {
        console.error(e);
        this.isLoading = false;
        this.isServerError = true;
      },
    });
  }

  prevSlide() {
    this.carousel.nativeElement.swiper.slidePrev(500);
  }

  nextSlide() {
    this.carousel.nativeElement.swiper.slideNext(500);
  }

  checkLockNavigation() {
    this.lockNext = this.carousel.nativeElement.swiper.isEnd;
    this.lockPrev = this.carousel.nativeElement.swiper.isBeginning;
    this.cdr.detectChanges();
  }
}
